import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  CashDenominationDto,
  CashDenominationListDto,
  CashDenominationFilterDto,
  CreateCashDenominationRequest,
  UpdateCashDenominationRequest,
} from '@/types/cashDenomination.types';

export const cashDenominationApi = {
  /** GET /api/v1/cash-denominations — paginated list with optional filter */
  getList: (filter?: CashDenominationFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<CashDenominationListDto>>>('/cash-denominations', {
      params: filter,
    }),

  /** GET /api/v1/cash-denominations/{id} — full denomination record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<CashDenominationDto>>(`/cash-denominations/${id}`),

  /** POST /api/v1/cash-denominations — create a new denomination */
  create: (data: CreateCashDenominationRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/cash-denominations', data),

  /** PUT /api/v1/cash-denominations/{id} — update denomination */
  update: (id: string, data: UpdateCashDenominationRequest) =>
    apiClient.put<ApiResponse<object>>(`/cash-denominations/${id}`, data),

  /** DELETE /api/v1/cash-denominations/{id} — soft-delete */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/cash-denominations/${id}`),
};
